import { CountrySectorData, FlattenedCountrySector, SectorHeader } from '../models/watchlist-country-sector.model';
import type { ColDef, ValueGetterParams } from 'ag-grid-community';
import { getCellClass } from '../watchlists-table/watchlists-table.config';

export const buildCountrySectorColumnDefs = (headers: SectorHeader[]): ColDef<FlattenedCountrySector>[] => {
  const sectorCol = (h: SectorHeader): ColDef<FlattenedCountrySector> => {
    const key = h.name;

    return {
      headerName: key,
      headerTooltip: key,
      colId: key,
      // Keep the raw cell value as the full CountrySectorData (handy for renderers, tooltips, exports)
      valueGetter: (p: ValueGetterParams<FlattenedCountrySector>) => p.data?.[key],

      // Show the score in the cell, but keep access to the full object via p.value
      valueFormatter: p => p.value?.sectorScore ?? '',

      cellClass: p => getCellClass(p.value?.sectorScore),

      // Enable sorting/filtering based on the score text
      sortable: true,
      filter: 'agTextColumnFilter',
      filterParams: {
        buttons: ['reset'],
        maxNumConditions: 1,
      },
      // Make filtering/sorting operate on the score string, not the whole object
      filterValueGetter: p => p.data?.[key]?.sectorScore ?? '',
      comparator: (a?: CountrySectorData, b?: CountrySectorData) =>
        (a?.sectorScore ?? '').localeCompare(b?.sectorScore ?? '', undefined, { numeric: true, sensitivity: 'base' }),
    };
  };

  return [
    {
      headerName: 'Country',
      field: 'countryName',
      colId: 'countryName',
      filter: true,
      sortable: true,
      flex: 2,
      filterParams: {
        buttons: ['reset'],
      },
    },
    ...headers.map(sectorCol),
  ];
};
